import React from "react";

import { formatINR } from "utils/format";

function OrderLines({ cart }) {
  const products = cart != null && cart.selectedProducts != null ? cart.selectedProducts : [];
  const benefit = cart != null ? cart.totalMaxPrice - cart.totalSellPrice : 0;

  return (
    <>
      <div className="hm-lines">
        {products.map((prd, i) => {
          const net = Math.round(prd.sellPrice * prd.qty);
          const saved = Math.round((prd.maxPrice - prd.sellPrice) * prd.qty);
          return (
            <div className="hm-line" key={prd.id != null ? prd.id : i}>
              <div className="hm-line-main">
                <div className="hm-line-name">{prd.name}</div>
                <div className="hm-line-meta">
                  {prd.qty} × &#x20B9;{formatINR(prd.maxPrice)}
                </div>
              </div>
              <div className="hm-line-amt">
                &#x20B9;{formatINR(net)}
                {saved >= 1 && (
                  <span className="hm-line-ben">Benefit &minus;&#x20B9;{formatINR(saved)}</span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="hm-totals">
        <div className="hm-total-row">
          <span>Contribution</span>
          <span>&#x20B9;{formatINR(cart != null ? cart.totalMaxPrice : 0)}</span>
        </div>
        {benefit >= 1 && (
          <div className="hm-total-row is-benefit">
            <span>Your benefit</span>
            <span>&minus;&#x20B9;{formatINR(benefit)}</span>
          </div>
        )}
        <div className="hm-total-row is-grand">
          <span>Amount payable</span>
          <span>&#x20B9;{formatINR(cart != null ? cart.totalSellPrice : 0)}</span>
        </div>
      </div>
    </>
  );
}

export default OrderLines;
